import { render, staticRenderFns } from "./index.vue?vue&type=template&id=5db748fe&scoped=true&lang=pug"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=5db748fe&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5db748fe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspaces/wuwow-junior-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5db748fe')) {
      api.createRecord('5db748fe', component.options)
    } else {
      api.reload('5db748fe', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=5db748fe&scoped=true&lang=pug", function () {
      api.rerender('5db748fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/vipMgm/customizedShareTextGoogle/index.vue"
export default component.exports